<template>
  <div class="linear-activity" v-if="$store.state.app.loading">
    <div :class="type" :style="{ width: width }"></div>
  </div>
</template>

<script>
export default {
  name: "spinner_002",
  props: {
    type: {
      type: String,
      default: "indeterminate"
    },
    width: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.linear-activity {
  overflow: hidden;
  width: 100%;
  height: 4px;
  background-color: #b3e5fc;
  margin: 0;
  position: fixed;
  top: 0;
  z-index: 9999;
}

.determinate {
  position: relative;
  max-width: 100%;
  height: 100%;
  -webkit-transition: width 500ms ease-out 1s;
  -moz-transition: width 500ms ease-out 1s;
  -o-transition: width 500ms ease-out 1s;
  transition: width 500ms ease-out 1s;
  background-color: #03a9f4;
}

.indeterminate {
  position: relative;
  width: 100%;
  height: 100%;
}

.indeterminate:before {
  content: "";
  position: absolute;
  height: 100%;
  background-color: #03a9f4;
  animation: indeterminate_first 1.5s infinite ease-out;
}

.indeterminate:after {
  content: "";
  position: absolute;
  height: 100%;
  background-color: #4fc3f7;
  animation: indeterminate_second 1.5s infinite ease-in;
}

@keyframes indeterminate_first {
  0% {
    left: -100%;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 10%;
  }
}

@keyframes indeterminate_second {
  0% {
    left: -150%;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 10%;
  }
}
</style>
